import { render } from "./DisplayPage.vue?vue&type=template&id=287fb12c&ts=true"
import script from "./DisplayPage.vue?vue&type=script&lang=ts"
export * from "./DisplayPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__